export default __webpack_public_path__ + "b60923f7fd0ff5296903ac904c1be667.jpg";